import { render, staticRenderFns } from "./Declaration.vue?vue&type=template&id=b1c80ff0&scoped=true&"
import script from "./Declaration.vue?vue&type=script&lang=js&"
export * from "./Declaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c80ff0",
  null
  
)

export default component.exports